import { gql } from '@apollo/client';
import useGQLMutation from 'src/lib/graphql/hooks/useGQLMutation';
const EP_UPLOAD_EF_MUTATION = gql `
  mutation EP_uploadEF($data: EPEFUploadInput!) {
    ep_uploadEF(data: $data) {
      sentForReview
    }
  }
`;
export function useUploadEFMutation(options) {
    return useGQLMutation(EP_UPLOAD_EF_MUTATION, options);
}
export default EP_UPLOAD_EF_MUTATION;
